// extracted by mini-css-extract-plugin
module.exports = {"Illustration":"Illustration_Illustration___Ox2a","aspect-ratio-1-1":"Illustration_aspect-ratio-1-1__pecG_","aspect-ratio-16-9":"Illustration_aspect-ratio-16-9__g_bVM"};